import { htmlToMarkdown } from '../components/RichEditor/richEditorUtils';
import hiveService from '../services/hive';

export const buildOptimisticReplyBody = ({ replyHtml, replyText, username, signature, signatureEnabled }) => {
  const normalizedReply = replyHtml && replyHtml.trim() ? htmlToMarkdown(replyHtml) : replyText;

  if (!username) {
    return { normalizedReply, optimisticReplyBody: normalizedReply };
  }

  const optimisticReplyBody = hiveService.appendUserSignatureForContext(
    normalizedReply,
    username,
    'comment',
    signature,
    signatureEnabled
  );

  return { normalizedReply, optimisticReplyBody };
};
